import React, { useState } from "react";
import logo from "../../../Assets/logo.svg";
import bg from "../../../Assets/dropdownbg.svg";
import insta from "../../../Assets/insta.svg";
import fb from "../../../Assets/fb.svg";
import linkedin from "../../../Assets/ln.svg";
import twitter from "../../../Assets/x.svg";
import mockup from "../../../Assets/Homemockup.webp";
import btn from "../../../Assets/Hoverbtn.svg";
import closebtn from "../../../Assets/closebtn.svg";

const socialMediaPlatforms = [
  // { name: "Facebook", icon: fb, link: "https://facebook.com" },
  // { name: "Instagram", icon: insta, link: "https://instagram.com" },
  { name: "LinkedIn", icon: linkedin, link: "https://www.linkedin.com/company/fractile-studio-llc/posts/?feedView=all" },
  // { name: "Twitter", icon: twitter, link: "https://twitter.com" },
];

const ServicesList = [
  {
    id: 1,
    ServiceName: "BIM/VDC Services",
    subService: [
      {
        id: 1,
        name: "Visualization",
        subsubservices: [
          { id: 1, name: "2D/3D Rendering", link: "/visualisation/2D&3D-rendering" },
          { id: 2, name: "3D Walkthroughs/ Flythrough", link: "/visualisation/3D-Walkthrough-Flythrough" },
          { id: 3, name: "4D Simulations", link: "/visualisation/4D-Simulations" },
        ],
      },
      {
        id: 2,
        name: "Modeling",
        subsubservices: [
          { id: 1, name: "2D(CAD/PDF) to Supplemental 3D Modeling", link: "/modeling/2D-to-3D-modeling" },
          { id: 2, name: "Supplemental Modeling", link: "/modeling/supplemental-modeling" },
          { id: 3, name: "Point Cloud to 3D Modeling", link: "/modeling/point-cloud-to-3D-modeling" },
        ],
      },
      {
        id: 3,
        name: "BIM Management",
        subsubservices: [
          { id: 1, name: "Clash Detection and Coordination", link: "/BIM-Management/clash-detection-and-coordination" },
          { id: 2, name: "BIM Execution Planning", link: "/BIM-Management/BIM-execution-planning" },
        ],
      },
    ],
  },
  {
    id: 2,
    ServiceName: "Project Engineering Services",
    subService: [
      { id: 1, name: "Shop Drawing Creation", link: "/shop-drawing-creation" },
      { id: 2, name: "2D Overlay", link: "/2D-overlay" },
      { id: 3, name: <>Document Management for RFIs,<br/> Submittals, & Change Orders</>, link: "/RFI-order-date-in-PM-software" },
    ],
  },
];

function DropdownWhatwedo({ onClose }) {
  const [selectedServiceId, setSelectedServiceId] = useState(ServicesList[0].id);
  const [expandedSubServiceId, setExpandedSubServiceId] = useState(null);

  const selectedService = ServicesList.find(service => service.id === selectedServiceId);

  return (
    <div className="tw-bg-[#157438] tw-min-h-screen">
      <div className="tw-max-w-screen-2xl tw-overflow-hidden tw-mx-auto tw-py-10 tw-px-12 tw-h-[100vh] tw-relative">
        <img src={bg} className="tw-absolute tw-top-1/2 -tw-translate-y-1/2 tw-pointer-events-none tw-h-full tw-w-full" alt="bg" />
        <img src={mockup} className="tw-w-[700px] tw-absolute tw-pointer-events-none tw-bottom-14 -tw-right-0" alt="mockup" />

        <button onClick={onClose} className="tw-absolute tw-z-[99] tw-right-12 tw-cursor-pointer">
          <img src={closebtn} alt="close" />
        </button>

        <div className="tw-w-full tw-flex tw-flex-col tw-justify-between tw-h-full tw-relative">
          <div className="tw-space-y-20">
            <img src={logo} alt="logo" />

            <div className="tw-flex tw-gap-12" style={{textAlign:'left'}}>
              <div className="tw-space-y-5">
                {ServicesList.map(service => (
                  <h2
                    key={service.id}
                    onClick={() => {
                      setSelectedServiceId(service.id);
                      setExpandedSubServiceId(null);
                    }}
                    className={`tw-text-white tw-font-medium tw-max-w-64 tw-text-[24px] tw-pb-2 tw-cursor-pointer ${selectedServiceId === service.id ? 'tw-border-b-2 tw-border-white' : 'tw-text-opacity-40'}`}
                  >
                    {service.ServiceName}
                  </h2>
                ))}
              </div>

              <div className="tw-space-y-5">
                {selectedService?.subService.map(sub => (
                  <div key={sub.id}>
                    <div
                      onClick={() => setExpandedSubServiceId(prev => (prev === sub.id ? null : sub.id))}
                      className="tw-w-[300px] tw-text-white tw-cursor-pointer tw-flex tw-justify-between tw-items-center group"
                    >                      
                      {sub.subsubservices && (
                        <>
                        <span className="tw-text-[20px]">{sub.name}</span>
                        <svg className={`                             
                             ${expandedSubServiceId === sub.id ? 'tw-rotate-360' : 'tw-rotate-180'}                        
                             `}
                             width="52" height="30" viewBox="0 0 52 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M34.3691 0.5L51.1338 29.5H16.8252L0.845703 0.5H34.3691Z" fill="white" stroke="white" className={`                             
                             ${expandedSubServiceId === sub.id ? 'tw-fill-[#FBFF7E] tw-stroke-[#FBFF7E]' : ''}                        
                             `}/>
                          <path d="M30 17L26 13L22 17" stroke="#157438" strokeWidth="2" strokeLinecap="round"/>
                        </svg>                        
                        </>
                      )}
                    </div>

                    <div
                      className={`tw-pl-4 tw-flex tw-flex-col tw-gap-2 tw-transition-all tw-duration-300 tw-ease-in-out ${
                        expandedSubServiceId === sub.id
                          ? 'tw-opacity-100 tw-translate-y-0'
                          : 'tw-opacity-0 -tw-translate-y-2 tw-h-0 tw-overflow-hidden'
                      }`} 
                    >
                      {expandedSubServiceId === sub.id &&
                        sub.subsubservices.map(item => (
                          <a key={item.id} href={item.link} className="tw-text-white tw-no-underline tw-text-sm">
                            {item.name}
                          </a>
                        ))}
                    </div>
                    
                    {!sub.subsubservices && (
                      <a
                        href={sub.link}
                        className="tw-text-white tw-no-underline tw-text-[20px]"
                      >
                        {sub.name}
                      </a>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="tw-flex tw-justify-start tw-items-end">
            {/* <a href="https://techxerro.com/" className="tw-no-underline tw-text-white tw-text-lg">
              Powered by Techxerro
            </a> */}
            <div className="tw-flex tw-space-x-2">
              {socialMediaPlatforms.map(platform => (
                <a
                  key={platform.name}
                  href={platform.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="!tw-flex !tw-justify-center !tw-items-center !tw-size-[70px] tw-skew-x-[20deg] tw-bg-[#ffffff50] hover:tw-bg-[#FBFF7E] hover:tw-color:[#fff] tw-transition-colors tw-duration-300 tw-cursor-pointer"
                > 
                  <img src={platform.icon} className="-tw-skew-x-[20deg] tw-color-[#FFF]" alt={platform.name} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DropdownWhatwedo;
